import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search-loads-v2",
  "use": "icon-search-loads-v2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search-loads-v2\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"m18.793 15.672 3.535 3.535a1 1 0 0 1 0 1.414l-.707.707a1 1 0 0 1-1.414 0l-3.535-3.535.353-1.768 1.768-.353zM10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 3a5 5 0 1 0 0 10 5 5 0 0 0 0-10z\" fill=\"#A4B4D0\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol